export function getConstructionTimeText(constructionTime: string) {
    return `do ${constructionTime} miesięcy`;
}
export function getConstructionTimeText(constructionTime: string) {
    return `do ${constructionTime} miesięcy`;
}
